var map = {
	"./buttons/download-black.svg": 69478,
	"./buttons/download-gf-pilot.svg": 58537,
	"./buttons/download-white.svg": 90683,
	"./buttons/github-white.svg": 65533,
	"./cards/IMG_1747.png": 5872,
	"./cards/IMG_1748.png": 78613,
	"./cards/bark-beetle-cropped.png": 7054,
	"./cards/damage-cropped.png": 6037,
	"./cards/drone-cropped-2.png": 32987,
	"./cards/drone-cropped.png": 79275,
	"./cards/everyday-inventory-cropped.png": 96397,
	"./cards/final-felling-drone-praxis-cropped.png": 92905,
	"./cards/fire-cropped.png": 55332,
	"./cards/forest-cropped.png": 97962,
	"./cards/harvest-cropped.png": 14402,
	"./cards/kopparfors-windfall-cropped.png": 37012,
	"./cards/man-cropped.png": 94298,
	"./cards/observations-cropped.png": 86292,
	"./cards/pilot-controller-cropped.png": 66426,
	"./cards/planning-drone-praxis-cropped.png": 2119,
	"./cards/sfab-forest-management-planning-cropped.png": 59648,
	"./cards/shade.png": 88567,
	"./cards/stora-enso-bark-beetle-cropped.png": 67935,
	"./cards/summer-cropped.png": 94111,
	"./cards/sun-cropped.png": 14806,
	"./cards/swamp-cropped.png": 2749,
	"./cards/tablet-cropped.png": 54238,
	"./cards/timber-cropped.png": 82050,
	"./cards/wildlife-cropped.png": 60038,
	"./cards/windthrow-cropped.png": 10795,
	"./confetti.png": 76118,
	"./gui/chevron-back-green.svg": 87049,
	"./gui/chevron-forward-green.svg": 59593,
	"./gui/menu-down-pine.svg": 96736,
	"./gui/menu-down-white.svg": 29850,
	"./gui/search-pine.svg": 10816,
	"./gui/warning.svg": 81764,
	"./logos/billerud.png": 39622,
	"./logos/billerud.svg": 74623,
	"./logos/gf-icon-pine.svg": 69911,
	"./logos/gf-icon-white.svg": 61375,
	"./logos/gm.png": 13285,
	"./logos/gm.svg": 15214,
	"./logos/kopparfors-circle.png": 67497,
	"./logos/kopparfors-circle.svg": 21647,
	"./logos/norra.png": 92382,
	"./logos/norra.svg": 63823,
	"./logos/retailers/cyberphoto.svg": 19659,
	"./logos/retailers/romvesen.png": 16345,
	"./logos/retailers/swedron.svg": 19748,
	"./logos/skogssallskapet-circle.png": 83032,
	"./logos/skogssallskapet-circle.svg": 29117,
	"./logos/skogssallskapet.png": 10802,
	"./logos/skogssallskapet.svg": 7535,
	"./logos/storaenso-circle.png": 24221,
	"./logos/storaenso-circle.svg": 87694,
	"./logos/storaenso.png": 9759,
	"./logos/storaenso.svg": 3593,
	"./markdown/bark_beetle/en/bark-beetle-observations-cropped.png": 24641,
	"./markdown/bark_beetle/en/bark-beetle-pre-observations-cropped.png": 63911,
	"./markdown/bark_beetle/sv/bark-beetle-observations-cropped.png": 666,
	"./markdown/bark_beetle/sv/bark-beetle-pre-observations-cropped.png": 62434,
	"./markdown/final_felling_drone_praxis/en/IMG_0001.png": 39488,
	"./markdown/final_felling_drone_praxis/en/IMG_0002.png": 52092,
	"./markdown/final_felling_drone_praxis/en/felling-drone-praxis-1-cropped.png": 19438,
	"./markdown/final_felling_drone_praxis/en/felling-drone-praxis-2-cropped.png": 67759,
	"./markdown/final_felling_drone_praxis/en/felling-drone-praxis-3-cropped.png": 77528,
	"./markdown/final_felling_drone_praxis/sv/IMG_0001.png": 66128,
	"./markdown/final_felling_drone_praxis/sv/IMG_0002.png": 61410,
	"./markdown/final_felling_drone_praxis/sv/felling-drone-praxis-1-cropped.png": 32209,
	"./markdown/final_felling_drone_praxis/sv/felling-drone-praxis-2-cropped.png": 53909,
	"./markdown/final_felling_drone_praxis/sv/felling-drone-praxis-3-cropped.png": 87174,
	"./markdown/guides/en/control-final-felling.png": 69302,
	"./markdown/guides/en/damage-inventory.png": 36904,
	"./markdown/guides/en/planning-projects.png": 12579,
	"./markdown/guides/sv/control-final-felling.png": 3925,
	"./markdown/guides/sv/damage-inventory.png": 14055,
	"./markdown/guides/sv/planning-projects.png": 84805,
	"./markdown/kopparfors_windfall/en/kopparfors-windfall-1-cropped.png": 68490,
	"./markdown/kopparfors_windfall/en/kopparfors-windfall-2-cropped.png": 20072,
	"./markdown/kopparfors_windfall/en/kopparfors-windfall-3-cropped.png": 23231,
	"./markdown/kopparfors_windfall/sv/kopparfors-windfall-1-cropped.png": 15001,
	"./markdown/kopparfors_windfall/sv/kopparfors-windfall-2-cropped.png": 65035,
	"./markdown/kopparfors_windfall/sv/kopparfors-windfall-3-cropped.png": 71481,
	"./markdown/manual_action_planning/en/Adding Action Objects to Action Plans - 1.png": 36890,
	"./markdown/manual_action_planning/en/Adding Action Objects to Action Plans - 2.png": 41868,
	"./markdown/manual_action_planning/en/Adding Action Objects to Action Plans - 3.png": 62127,
	"./markdown/manual_action_planning/en/Adding Action Objects to Action Plans - 4.png": 82291,
	"./markdown/manual_action_planning/en/Adding Action Objects to Action Plans - 5.png": 98626,
	"./markdown/manual_action_planning/en/Adding Actions to Action Plans - 1.png": 5237,
	"./markdown/manual_action_planning/en/Adding Actions to Action Plans - 2.png": 26562,
	"./markdown/manual_action_planning/en/Adding Actions to Action Plans - 3.png": 65764,
	"./markdown/manual_action_planning/en/Adding Actions to Action Plans - 4.png": 44189,
	"./markdown/manual_action_planning/en/Adding Library Images to Project Images - 1.png": 81809,
	"./markdown/manual_action_planning/en/Adding Library Images to Project Images - 2.png": 90088,
	"./markdown/manual_action_planning/en/Adding Map Snapshots to Project Images - 1.png": 2189,
	"./markdown/manual_action_planning/en/Adding Map Snapshots to Project Images - 2.png": 24541,
	"./markdown/manual_action_planning/en/Adding Point Observation Images to Project Images - 1.png": 54514,
	"./markdown/manual_action_planning/en/Adding Point Observation Images to Project Images - 2.png": 75075,
	"./markdown/manual_action_planning/en/Gallery View.png": 92873,
	"./markdown/manual_action_planning/en/Generating Action Proposal PDFs - 1.png": 59334,
	"./markdown/manual_action_planning/en/Generating Action Proposal PDFs - 2.png": 30055,
	"./markdown/manual_action_planning/en/Generating Action Proposal PDFs - 3.png": 29067,
	"./markdown/manual_action_planning/en/Generating Action Proposal PDFs - 4.png": 44281,
	"./markdown/manual_action_planning/en/Removing Actions from Action Plans - 1.png": 18818,
	"./markdown/manual_action_planning/en/Removing Actions from Action Plans - 2.png": 59717,
	"./markdown/manual_action_planning/sv/Adding Action Objects to Action Plans - 1.png": 84349,
	"./markdown/manual_action_planning/sv/Adding Action Objects to Action Plans - 2.png": 73684,
	"./markdown/manual_action_planning/sv/Adding Action Objects to Action Plans - 3.png": 39313,
	"./markdown/manual_action_planning/sv/Adding Action Objects to Action Plans - 4.png": 30511,
	"./markdown/manual_action_planning/sv/Adding Action Objects to Action Plans - 5.png": 96194,
	"./markdown/manual_action_planning/sv/Adding Actions to Action Plans - 1.png": 80382,
	"./markdown/manual_action_planning/sv/Adding Actions to Action Plans - 2.png": 65603,
	"./markdown/manual_action_planning/sv/Adding Actions to Action Plans - 3.png": 72929,
	"./markdown/manual_action_planning/sv/Adding Actions to Action Plans - 4.png": 24533,
	"./markdown/manual_action_planning/sv/Adding Library Images to Project Images - 1.png": 43359,
	"./markdown/manual_action_planning/sv/Adding Library Images to Project Images - 2.png": 96592,
	"./markdown/manual_action_planning/sv/Adding Map Snapshots to Project Images - 1.png": 36805,
	"./markdown/manual_action_planning/sv/Adding Map Snapshots to Project Images - 2.png": 18314,
	"./markdown/manual_action_planning/sv/Adding Point Observation Images to Project Images - 1.png": 66184,
	"./markdown/manual_action_planning/sv/Adding Point Observation Images to Project Images - 2.png": 80148,
	"./markdown/manual_action_planning/sv/Gallery View.png": 47591,
	"./markdown/manual_action_planning/sv/Generating Action Proposal PDFs - 1.png": 53198,
	"./markdown/manual_action_planning/sv/Generating Action Proposal PDFs - 2.png": 80960,
	"./markdown/manual_action_planning/sv/Generating Action Proposal PDFs - 3.png": 19900,
	"./markdown/manual_action_planning/sv/Generating Action Proposal PDFs - 4.png": 50790,
	"./markdown/manual_action_planning/sv/Removing Actions from Action Plans - 1.png": 28474,
	"./markdown/manual_action_planning/sv/Removing Actions from Action Plans - 2.png": 79566,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 1.png": 39265,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 10.png": 57005,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 2.png": 58814,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 3.png": 13380,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 4.png": 6515,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 5.png": 57494,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 6.png": 93502,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 7.png": 92761,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 8.png": 97574,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 1 - 9.png": 60964,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 1.png": 91447,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 2.png": 73866,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 3.png": 57636,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 4.png": 75511,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 5.png": 45101,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 6.png": 52316,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 7.png": 75906,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 8.png": 95528,
	"./markdown/manual_advanced/en/Creating GeoJPEG in QGIS - Alternative 2 - 9.png": 48348,
	"./markdown/manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 1.png": 19861,
	"./markdown/manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 2.png": 14284,
	"./markdown/manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 3.png": 57405,
	"./markdown/manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 4.png": 14106,
	"./markdown/manual_advanced/en/Erasing Sensitive Parts of Rapid Orthophotos - 5.png": 21144,
	"./markdown/manual_advanced/en/Exporting Rapid Orthophotos - 1.png": 42293,
	"./markdown/manual_advanced/en/Exporting Rapid Orthophotos - 2.png": 18642,
	"./markdown/manual_advanced/en/Exporting Rapid Orthophotos - 3.png": 55631,
	"./markdown/manual_advanced/en/Importing Photos as Points - 1.png": 73054,
	"./markdown/manual_advanced/en/Importing Photos as Points - 2.png": 4338,
	"./markdown/manual_advanced/en/Importing Photos as Points - 3.png": 38679,
	"./markdown/manual_advanced/en/Language & Region.png": 83061,
	"./markdown/manual_advanced/en/Select Language.png": 44906,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 1.png": 23262,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 10.png": 6477,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 2.png": 72921,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 3.png": 43873,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 4.png": 24441,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 5.png": 68474,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 6.png": 24345,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 7.png": 58418,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 8.png": 14061,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 1 - 9.png": 99433,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 1.png": 76324,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 2.png": 46771,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 3.png": 63753,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 4.png": 34252,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 5.png": 43908,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 6.png": 1994,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 7.png": 15478,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 8.png": 15678,
	"./markdown/manual_advanced/sv/Creating GeoJPEG in QGIS - Alternative 2 - 9.png": 30839,
	"./markdown/manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 1.png": 29124,
	"./markdown/manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 2.png": 13009,
	"./markdown/manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 3.png": 37455,
	"./markdown/manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 4.png": 52438,
	"./markdown/manual_advanced/sv/Erasing Sensitive Parts of Rapid Orthophotos - 5.png": 54693,
	"./markdown/manual_advanced/sv/Exporting Rapid Orthophotos - 1.png": 17546,
	"./markdown/manual_advanced/sv/Exporting Rapid Orthophotos - 2.png": 82524,
	"./markdown/manual_advanced/sv/Exporting Rapid Orthophotos - 3.png": 38307,
	"./markdown/manual_advanced/sv/Importing Photos as Points - 1.png": 7420,
	"./markdown/manual_advanced/sv/Importing Photos as Points - 2.png": 36370,
	"./markdown/manual_advanced/sv/Importing Photos as Points - 3.png": 97200,
	"./markdown/manual_advanced/sv/Language & Region.png": 60985,
	"./markdown/manual_advanced/sv/Select Language.png": 61295,
	"./markdown/manual_basics/en/Active Tracklog - 1.png": 21909,
	"./markdown/manual_basics/en/Active Tracklog - 2.png": 50275,
	"./markdown/manual_basics/en/Active Tracklog - 3.png": 6966,
	"./markdown/manual_basics/en/AddNodeAtDronePositionTool.svg": 94193,
	"./markdown/manual_basics/en/AddNodeAtPositionTool.svg": 6105,
	"./markdown/manual_basics/en/Adding Photos from Camera - 1.png": 42251,
	"./markdown/manual_basics/en/Adding Photos from Camera - 2.png": 1562,
	"./markdown/manual_basics/en/Adding Photos from Camera - 3.png": 28269,
	"./markdown/manual_basics/en/Adding Photos from Camera - 4.png": 8921,
	"./markdown/manual_basics/en/Adding Photos from Camera - 5.png": 2969,
	"./markdown/manual_basics/en/Adding Photos from Library - 1.png": 48036,
	"./markdown/manual_basics/en/Adding Photos from Library - 2.png": 34755,
	"./markdown/manual_basics/en/Adding Photos from Library - 3.png": 1062,
	"./markdown/manual_basics/en/Adding Photos from Library - 4.png": 79091,
	"./markdown/manual_basics/en/Compact Example (iPhone) - Main Menu.png": 13716,
	"./markdown/manual_basics/en/Compact Example (iPhone) - Map.png": 42132,
	"./markdown/manual_basics/en/Copying Items in Teams - 1.png": 14994,
	"./markdown/manual_basics/en/Copying Items in Teams - 2.png": 86710,
	"./markdown/manual_basics/en/Copying Items in Teams - 3.png": 75514,
	"./markdown/manual_basics/en/Copying Items in Teams - 4.png": 39291,
	"./markdown/manual_basics/en/Copying Items in Teams - 5.png": 37025,
	"./markdown/manual_basics/en/Copying Items in Teams - 6.png": 41910,
	"./markdown/manual_basics/en/Creating Managed Areas - Draw & Import - 1.png": 40976,
	"./markdown/manual_basics/en/Creating Managed Areas - Draw & Import - 2.png": 13933,
	"./markdown/manual_basics/en/Creating Managed Areas - Draw - 3.png": 56919,
	"./markdown/manual_basics/en/Creating Managed Areas - Draw - 4.png": 58218,
	"./markdown/manual_basics/en/Creating Managed Areas - Draw - 5.png": 46624,
	"./markdown/manual_basics/en/Creating Managed Areas - Draw - 6.png": 44652,
	"./markdown/manual_basics/en/Creating Managed Areas - Estate - 1.png": 4713,
	"./markdown/manual_basics/en/Creating Managed Areas - Estate - 2.png": 34541,
	"./markdown/manual_basics/en/Creating Managed Areas - Estate - 3.png": 92093,
	"./markdown/manual_basics/en/Creating Managed Areas - Estate - 4.png": 87562,
	"./markdown/manual_basics/en/Creating Managed Areas - Import - 3.png": 36797,
	"./markdown/manual_basics/en/Creating Managed Areas - Import - 4.png": 26906,
	"./markdown/manual_basics/en/Creating Managed Areas - Import - 5.png": 97314,
	"./markdown/manual_basics/en/Creating Observations - Image Viewer - 1.png": 44830,
	"./markdown/manual_basics/en/Creating Observations - Image Viewer - 2.png": 25387,
	"./markdown/manual_basics/en/Creating Observations - Image Viewer - 3.png": 56192,
	"./markdown/manual_basics/en/Creating Observations - Map - 1.png": 15257,
	"./markdown/manual_basics/en/Creating Observations - Map - 2.png": 75369,
	"./markdown/manual_basics/en/Creating Observations - Map - 3.png": 35241,
	"./markdown/manual_basics/en/Creating Observations - Map - 4.png": 49431,
	"./markdown/manual_basics/en/Creating Observations - Map - 5.png": 73776,
	"./markdown/manual_basics/en/Creating Projects - 1.png": 40373,
	"./markdown/manual_basics/en/Creating Projects - 2.png": 65284,
	"./markdown/manual_basics/en/Creating Projects - 3.png": 16175,
	"./markdown/manual_basics/en/Creating Teams - 1.png": 87999,
	"./markdown/manual_basics/en/Creating Teams - 2.png": 30593,
	"./markdown/manual_basics/en/DeleteNodesTool.svg": 43194,
	"./markdown/manual_basics/en/DrawTool.svg": 36401,
	"./markdown/manual_basics/en/DroneTrackTool.svg": 19858,
	"./markdown/manual_basics/en/EditTool.svg": 12774,
	"./markdown/manual_basics/en/Filtering Compartments - 1.png": 88446,
	"./markdown/manual_basics/en/Filtering Compartments - 2.png": 98574,
	"./markdown/manual_basics/en/Filtering Compartments - 3.png": 94151,
	"./markdown/manual_basics/en/Filtering Compartments - 4.png": 20481,
	"./markdown/manual_basics/en/Geometry Editor.png": 68437,
	"./markdown/manual_basics/en/Managed Area - Available Offline.png": 81819,
	"./markdown/manual_basics/en/Managed Area.png": 6941,
	"./markdown/manual_basics/en/Map Layers.png": 48790,
	"./markdown/manual_basics/en/MergeTool.svg": 28843,
	"./markdown/manual_basics/en/Moving Items in Projects - 1.png": 59711,
	"./markdown/manual_basics/en/Moving Items in Projects - 2.png": 5933,
	"./markdown/manual_basics/en/Moving Items in Projects - 3.png": 27005,
	"./markdown/manual_basics/en/Moving Items in Projects - 4.png": 33240,
	"./markdown/manual_basics/en/Moving Items in Projects - 5.png": 70488,
	"./markdown/manual_basics/en/Moving Items in Projects - 6.png": 81335,
	"./markdown/manual_basics/en/Navigate to Teams from Managed Areas - 1.png": 53628,
	"./markdown/manual_basics/en/Navigate to Teams from Managed Areas - 2.png": 11044,
	"./markdown/manual_basics/en/Project - Restoring Deleted Item - 1.png": 64782,
	"./markdown/manual_basics/en/Project - Restoring Deleted Item - 2.png": 54746,
	"./markdown/manual_basics/en/Redo.svg": 62495,
	"./markdown/manual_basics/en/Report Error - 1.png": 31170,
	"./markdown/manual_basics/en/Report Error - 2.png": 10235,
	"./markdown/manual_basics/en/Report Error - 3.png": 83619,
	"./markdown/manual_basics/en/Select Map - 1.png": 96057,
	"./markdown/manual_basics/en/Select Map - 2.png": 67382,
	"./markdown/manual_basics/en/Select Map - 3.png": 50784,
	"./markdown/manual_basics/en/Select Map - 4.png": 81411,
	"./markdown/manual_basics/en/Signing In - 1.png": 52893,
	"./markdown/manual_basics/en/Signing In - 2.png": 52174,
	"./markdown/manual_basics/en/SplitTool.svg": 20614,
	"./markdown/manual_basics/en/SubtractTool.svg": 38653,
	"./markdown/manual_basics/en/Team - Restoring Deleted Item - 1.png": 25811,
	"./markdown/manual_basics/en/Team - Restoring Deleted Item - 2.png": 14873,
	"./markdown/manual_basics/en/The GUI - Overview.png": 5446,
	"./markdown/manual_basics/en/The GUI - Search.png": 28963,
	"./markdown/manual_basics/en/The GUI - The Detail Panel.png": 37415,
	"./markdown/manual_basics/en/The GUI - The Main Menu.png": 60563,
	"./markdown/manual_basics/en/The GUI - The Map.png": 5564,
	"./markdown/manual_basics/en/The GUI - The More-menu.png": 42562,
	"./markdown/manual_basics/en/TrackTool.svg": 65522,
	"./markdown/manual_basics/en/Undo.svg": 88895,
	"./markdown/manual_basics/sv/Active Tracklog - 1.png": 19586,
	"./markdown/manual_basics/sv/Active Tracklog - 2.png": 32380,
	"./markdown/manual_basics/sv/Active Tracklog - 3.png": 31404,
	"./markdown/manual_basics/sv/AddNodeAtDronePositionTool.svg": 6511,
	"./markdown/manual_basics/sv/AddNodeAtPositionTool.svg": 75592,
	"./markdown/manual_basics/sv/Adding Photos from Camera - 1.png": 99489,
	"./markdown/manual_basics/sv/Adding Photos from Camera - 2.png": 44507,
	"./markdown/manual_basics/sv/Adding Photos from Camera - 3.png": 77478,
	"./markdown/manual_basics/sv/Adding Photos from Camera - 4.png": 68122,
	"./markdown/manual_basics/sv/Adding Photos from Camera - 5.png": 23006,
	"./markdown/manual_basics/sv/Adding Photos from Library - 1.png": 47786,
	"./markdown/manual_basics/sv/Adding Photos from Library - 2.png": 86107,
	"./markdown/manual_basics/sv/Adding Photos from Library - 3.png": 21852,
	"./markdown/manual_basics/sv/Adding Photos from Library - 4.png": 25901,
	"./markdown/manual_basics/sv/Compact Example (iPhone) - Main Menu.png": 14645,
	"./markdown/manual_basics/sv/Compact Example (iPhone) - Map.png": 57502,
	"./markdown/manual_basics/sv/Copying Items in Teams - 1.png": 90512,
	"./markdown/manual_basics/sv/Copying Items in Teams - 2.png": 88727,
	"./markdown/manual_basics/sv/Copying Items in Teams - 3.png": 52991,
	"./markdown/manual_basics/sv/Copying Items in Teams - 4.png": 42513,
	"./markdown/manual_basics/sv/Copying Items in Teams - 5.png": 15836,
	"./markdown/manual_basics/sv/Copying Items in Teams - 6.png": 40822,
	"./markdown/manual_basics/sv/Creating Managed Areas - Draw & Import - 1.png": 29234,
	"./markdown/manual_basics/sv/Creating Managed Areas - Draw & Import - 2.png": 54515,
	"./markdown/manual_basics/sv/Creating Managed Areas - Draw - 3.png": 44715,
	"./markdown/manual_basics/sv/Creating Managed Areas - Draw - 4.png": 44497,
	"./markdown/manual_basics/sv/Creating Managed Areas - Draw - 5.png": 52669,
	"./markdown/manual_basics/sv/Creating Managed Areas - Draw - 6.png": 91885,
	"./markdown/manual_basics/sv/Creating Managed Areas - Estate - 1.png": 93906,
	"./markdown/manual_basics/sv/Creating Managed Areas - Estate - 2.png": 28402,
	"./markdown/manual_basics/sv/Creating Managed Areas - Estate - 3.png": 87661,
	"./markdown/manual_basics/sv/Creating Managed Areas - Estate - 4.png": 53449,
	"./markdown/manual_basics/sv/Creating Managed Areas - Import - 3.png": 58850,
	"./markdown/manual_basics/sv/Creating Managed Areas - Import - 4.png": 36989,
	"./markdown/manual_basics/sv/Creating Managed Areas - Import - 5.png": 486,
	"./markdown/manual_basics/sv/Creating Observations - Image Viewer - 1.png": 60621,
	"./markdown/manual_basics/sv/Creating Observations - Image Viewer - 2.png": 88944,
	"./markdown/manual_basics/sv/Creating Observations - Image Viewer - 3.png": 58164,
	"./markdown/manual_basics/sv/Creating Observations - Map - 1.png": 22963,
	"./markdown/manual_basics/sv/Creating Observations - Map - 2.png": 27894,
	"./markdown/manual_basics/sv/Creating Observations - Map - 3.png": 11258,
	"./markdown/manual_basics/sv/Creating Observations - Map - 4.png": 74725,
	"./markdown/manual_basics/sv/Creating Observations - Map - 5.png": 64229,
	"./markdown/manual_basics/sv/Creating Projects - 1.png": 15292,
	"./markdown/manual_basics/sv/Creating Projects - 2.png": 29017,
	"./markdown/manual_basics/sv/Creating Projects - 3.png": 3651,
	"./markdown/manual_basics/sv/Creating Teams - 1.png": 72593,
	"./markdown/manual_basics/sv/Creating Teams - 2.png": 27024,
	"./markdown/manual_basics/sv/DeleteNodesTool.svg": 34740,
	"./markdown/manual_basics/sv/DrawTool.svg": 96139,
	"./markdown/manual_basics/sv/DroneTrackTool.svg": 36318,
	"./markdown/manual_basics/sv/EditTool.svg": 65481,
	"./markdown/manual_basics/sv/Filtering Compartments - 1.png": 97941,
	"./markdown/manual_basics/sv/Filtering Compartments - 2.png": 42907,
	"./markdown/manual_basics/sv/Filtering Compartments - 3.png": 17102,
	"./markdown/manual_basics/sv/Filtering Compartments - 4.png": 59203,
	"./markdown/manual_basics/sv/Geometry Editor.png": 92032,
	"./markdown/manual_basics/sv/Managed Area - Available Offline.png": 99299,
	"./markdown/manual_basics/sv/Managed Area.png": 34281,
	"./markdown/manual_basics/sv/Map Layers.png": 15036,
	"./markdown/manual_basics/sv/MergeTool.svg": 66694,
	"./markdown/manual_basics/sv/Moving Items in Projects - 1.png": 75987,
	"./markdown/manual_basics/sv/Moving Items in Projects - 2.png": 50038,
	"./markdown/manual_basics/sv/Moving Items in Projects - 3.png": 29599,
	"./markdown/manual_basics/sv/Moving Items in Projects - 4.png": 5432,
	"./markdown/manual_basics/sv/Moving Items in Projects - 5.png": 96494,
	"./markdown/manual_basics/sv/Moving Items in Projects - 6.png": 41871,
	"./markdown/manual_basics/sv/Navigate to Teams from Managed Areas - 1.png": 34970,
	"./markdown/manual_basics/sv/Navigate to Teams from Managed Areas - 2.png": 41950,
	"./markdown/manual_basics/sv/Project - Restoring Deleted Item - 1.png": 8909,
	"./markdown/manual_basics/sv/Project - Restoring Deleted Item - 2.png": 51326,
	"./markdown/manual_basics/sv/Redo.svg": 46706,
	"./markdown/manual_basics/sv/Report Error - 1.png": 99960,
	"./markdown/manual_basics/sv/Report Error - 2.png": 91380,
	"./markdown/manual_basics/sv/Report Error - 3.png": 3909,
	"./markdown/manual_basics/sv/Select Map - 1.png": 54667,
	"./markdown/manual_basics/sv/Select Map - 2.png": 98286,
	"./markdown/manual_basics/sv/Select Map - 3.png": 44812,
	"./markdown/manual_basics/sv/Select Map - 4.png": 32791,
	"./markdown/manual_basics/sv/Signing In - 1.png": 36341,
	"./markdown/manual_basics/sv/Signing In - 2.png": 14001,
	"./markdown/manual_basics/sv/SplitTool.svg": 83946,
	"./markdown/manual_basics/sv/SubtractTool.svg": 78040,
	"./markdown/manual_basics/sv/Team - Restoring Deleted Item - 1.png": 43538,
	"./markdown/manual_basics/sv/Team - Restoring Deleted Item - 2.png": 47018,
	"./markdown/manual_basics/sv/The GUI - Overview.png": 58010,
	"./markdown/manual_basics/sv/The GUI - Search.png": 25757,
	"./markdown/manual_basics/sv/The GUI - The Detail Panel.png": 71321,
	"./markdown/manual_basics/sv/The GUI - The Main Menu.png": 11903,
	"./markdown/manual_basics/sv/The GUI - The Map.png": 74017,
	"./markdown/manual_basics/sv/The GUI - The More-menu.png": 72487,
	"./markdown/manual_basics/sv/TrackTool.svg": 90423,
	"./markdown/manual_basics/sv/Undo.svg": 47603,
	"./markdown/manual_drone_operations/en/Connecting to Enterprise Drone - 1.png": 12951,
	"./markdown/manual_drone_operations/en/Connecting to Enterprise Drone - 2.png": 20580,
	"./markdown/manual_drone_operations/en/Connecting to Enterprise Drone - 3.png": 29090,
	"./markdown/manual_drone_operations/en/Connecting to Enterprise Drone - 4.png": 75237,
	"./markdown/manual_drone_operations/en/Connecting to Enterprise Drone - 5.png": 10123,
	"./markdown/manual_drone_operations/en/Connecting to Enterprise Drone - 6.png": 78675,
	"./markdown/manual_drone_operations/en/Connecting to Enterprise Drone - 7.png": 85022,
	"./markdown/manual_drone_operations/en/Connecting to Other Drone - 1.png": 7631,
	"./markdown/manual_drone_operations/en/Connecting to Other Drone - 2.png": 2277,
	"./markdown/manual_drone_operations/en/Connecting to Other Drone - 3.png": 80581,
	"./markdown/manual_drone_operations/en/Connecting to Other Drone - 4.png": 22470,
	"./markdown/manual_drone_operations/en/Creating Drone Missions - 1.png": 14301,
	"./markdown/manual_drone_operations/en/Creating Drone Missions - 2.png": 76775,
	"./markdown/manual_drone_operations/en/Creating Drone Missions - 3.png": 57728,
	"./markdown/manual_drone_operations/en/Creating Drone Missions - 4.png": 11380,
	"./markdown/manual_drone_operations/en/Creating Drone Missions - 5.png": 1656,
	"./markdown/manual_drone_operations/en/Creating Drone Missions - 6.png": 87467,
	"./markdown/manual_drone_operations/en/Displaying Rapid Orthophotos - 1.png": 20859,
	"./markdown/manual_drone_operations/en/Displaying Rapid Orthophotos - 2.png": 22504,
	"./markdown/manual_drone_operations/en/Downloading Rapid Orthophotos - 1.png": 22544,
	"./markdown/manual_drone_operations/en/Downloading Rapid Orthophotos - 2.png": 39081,
	"./markdown/manual_drone_operations/en/Downloading Rapid Orthophotos - 3.png": 96365,
	"./markdown/manual_drone_operations/en/Hide or Clear Flight Path.png": 71999,
	"./markdown/manual_drone_operations/en/Importing Flight Images - 1.png": 63666,
	"./markdown/manual_drone_operations/en/Importing Flight Images - 2.png": 67275,
	"./markdown/manual_drone_operations/en/Importing Flight Images - 3.png": 15486,
	"./markdown/manual_drone_operations/en/Merging Rapid Orthophotos - 1.png": 70815,
	"./markdown/manual_drone_operations/en/Merging Rapid Orthophotos - 2.png": 54325,
	"./markdown/manual_drone_operations/en/Merging Rapid Orthophotos - 3.png": 5474,
	"./markdown/manual_drone_operations/en/Merging Rapid Orthophotos - 4.png": 49112,
	"./markdown/manual_drone_operations/en/Merging Rapid Orthophotos - 5.png": 63498,
	"./markdown/manual_drone_operations/en/Merging Rapid Orthophotos - 6.png": 43162,
	"./markdown/manual_drone_operations/en/Merging Rapid Orthophotos - 7.png": 17042,
	"./markdown/manual_drone_operations/en/RNG Switch.png": 91882,
	"./markdown/manual_drone_operations/en/Show Temp Switch.png": 67484,
	"./markdown/manual_drone_operations/en/Starting Drone Missions.png": 77872,
	"./markdown/manual_drone_operations/en/The Drone GUI - GF - Drone.png": 21046,
	"./markdown/manual_drone_operations/en/The Drone GUI - GF - Map.png": 75764,
	"./markdown/manual_drone_operations/en/The Drone GUI - GF Pilot.png": 80135,
	"./markdown/manual_drone_operations/sv/Connecting to Enterprise Drone - 1.png": 47122,
	"./markdown/manual_drone_operations/sv/Connecting to Enterprise Drone - 2.png": 96169,
	"./markdown/manual_drone_operations/sv/Connecting to Enterprise Drone - 3.png": 79685,
	"./markdown/manual_drone_operations/sv/Connecting to Enterprise Drone - 4.png": 92500,
	"./markdown/manual_drone_operations/sv/Connecting to Enterprise Drone - 5.png": 95955,
	"./markdown/manual_drone_operations/sv/Connecting to Enterprise Drone - 6.png": 58730,
	"./markdown/manual_drone_operations/sv/Connecting to Enterprise Drone - 7.png": 40663,
	"./markdown/manual_drone_operations/sv/Connecting to Other Drone - 1.png": 71938,
	"./markdown/manual_drone_operations/sv/Connecting to Other Drone - 2.png": 48223,
	"./markdown/manual_drone_operations/sv/Connecting to Other Drone - 3.png": 80333,
	"./markdown/manual_drone_operations/sv/Connecting to Other Drone - 4.png": 48081,
	"./markdown/manual_drone_operations/sv/Creating Drone Missions - 1.png": 35412,
	"./markdown/manual_drone_operations/sv/Creating Drone Missions - 2.png": 25297,
	"./markdown/manual_drone_operations/sv/Creating Drone Missions - 3.png": 62586,
	"./markdown/manual_drone_operations/sv/Creating Drone Missions - 4.png": 46552,
	"./markdown/manual_drone_operations/sv/Creating Drone Missions - 5.png": 35441,
	"./markdown/manual_drone_operations/sv/Creating Drone Missions - 6.png": 68082,
	"./markdown/manual_drone_operations/sv/Displaying Rapid Orthophotos - 1.png": 97157,
	"./markdown/manual_drone_operations/sv/Displaying Rapid Orthophotos - 2.png": 56272,
	"./markdown/manual_drone_operations/sv/Downloading Rapid Orthophotos - 1.png": 26045,
	"./markdown/manual_drone_operations/sv/Downloading Rapid Orthophotos - 2.png": 18876,
	"./markdown/manual_drone_operations/sv/Downloading Rapid Orthophotos - 3.png": 82020,
	"./markdown/manual_drone_operations/sv/Hide or Clear Flight Path.png": 31817,
	"./markdown/manual_drone_operations/sv/Importing Flight Images - 1.png": 50601,
	"./markdown/manual_drone_operations/sv/Importing Flight Images - 2.png": 67687,
	"./markdown/manual_drone_operations/sv/Importing Flight Images - 3.png": 95747,
	"./markdown/manual_drone_operations/sv/Merging Rapid Orthophotos - 1.png": 44051,
	"./markdown/manual_drone_operations/sv/Merging Rapid Orthophotos - 2.png": 98274,
	"./markdown/manual_drone_operations/sv/Merging Rapid Orthophotos - 3.png": 59624,
	"./markdown/manual_drone_operations/sv/Merging Rapid Orthophotos - 4.png": 70786,
	"./markdown/manual_drone_operations/sv/Merging Rapid Orthophotos - 5.png": 72119,
	"./markdown/manual_drone_operations/sv/Merging Rapid Orthophotos - 6.png": 89903,
	"./markdown/manual_drone_operations/sv/Merging Rapid Orthophotos - 7.png": 21257,
	"./markdown/manual_drone_operations/sv/RNG Switch.png": 35503,
	"./markdown/manual_drone_operations/sv/Show Temp Switch.png": 91647,
	"./markdown/manual_drone_operations/sv/Starting Drone Missions.png": 30255,
	"./markdown/manual_drone_operations/sv/The Drone GUI - GF - Drone.png": 17615,
	"./markdown/manual_drone_operations/sv/The Drone GUI - GF - Map.png": 36862,
	"./markdown/manual_drone_operations/sv/The Drone GUI - GF Pilot.png": 65650,
	"./markdown/manual_forest_management_planning/en/Creating Forest Management Planning Projects - 1.png": 29122,
	"./markdown/manual_forest_management_planning/en/Creating Forest Management Planning Projects - 2.png": 11023,
	"./markdown/manual_forest_management_planning/en/Extending Compartments - 1.png": 68459,
	"./markdown/manual_forest_management_planning/en/Extending Compartments - 2.png": 37609,
	"./markdown/manual_forest_management_planning/en/Extending Compartments - 3.png": 60685,
	"./markdown/manual_forest_management_planning/en/Merging Compartments - 1.png": 2976,
	"./markdown/manual_forest_management_planning/en/Merging Compartments - 2.png": 77037,
	"./markdown/manual_forest_management_planning/en/Merging Compartments - 3.png": 27502,
	"./markdown/manual_forest_management_planning/en/Splitting Compartments - 1.png": 20714,
	"./markdown/manual_forest_management_planning/en/Splitting Compartments - 2.png": 86386,
	"./markdown/manual_forest_management_planning/en/Splitting Compartments - 3.png": 12860,
	"./markdown/manual_forest_management_planning/en/Splitting Compartments - 4.png": 45335,
	"./markdown/manual_forest_management_planning/sv/Creating Forest Management Planning Projects - 1.png": 27737,
	"./markdown/manual_forest_management_planning/sv/Creating Forest Management Planning Projects - 2.png": 87784,
	"./markdown/manual_forest_management_planning/sv/Extending Compartments - 1.png": 77538,
	"./markdown/manual_forest_management_planning/sv/Extending Compartments - 2.png": 77052,
	"./markdown/manual_forest_management_planning/sv/Extending Compartments - 3.png": 16536,
	"./markdown/manual_forest_management_planning/sv/Merging Compartments - 1.png": 25377,
	"./markdown/manual_forest_management_planning/sv/Merging Compartments - 2.png": 59846,
	"./markdown/manual_forest_management_planning/sv/Merging Compartments - 3.png": 18126,
	"./markdown/manual_forest_management_planning/sv/Splitting Compartments - 1.png": 74500,
	"./markdown/manual_forest_management_planning/sv/Splitting Compartments - 2.png": 7775,
	"./markdown/manual_forest_management_planning/sv/Splitting Compartments - 3.png": 19966,
	"./markdown/manual_forest_management_planning/sv/Splitting Compartments - 4.png": 34984,
	"./markdown/planning_drone_praxis/en/planning-drone-praxis-1-cropped.png": 12538,
	"./markdown/planning_drone_praxis/en/planning-drone-praxis-2-cropped.png": 63265,
	"./markdown/planning_drone_praxis/sv/planning-drone-praxis-1-cropped.png": 82541,
	"./markdown/planning_drone_praxis/sv/planning-drone-praxis-2-cropped.png": 35209,
	"./markdown/sfab_forest_management_planning/en/sfab-forest-management-planning-1-cropped.png": 49099,
	"./markdown/sfab_forest_management_planning/en/sfab-forest-management-planning-2-cropped.png": 91694,
	"./markdown/sfab_forest_management_planning/sv/sfab-forest-management-planning-1-cropped.png": 21421,
	"./markdown/sfab_forest_management_planning/sv/sfab-forest-management-planning-2-cropped.png": 13039,
	"./markdown/stora_enso_bark_beetle/en/stora-enso-bark-beetle-1-cropped.png": 2053,
	"./markdown/stora_enso_bark_beetle/en/stora-enso-bark-beetle-2-cropped.png": 95037,
	"./markdown/stora_enso_bark_beetle/sv/stora-enso-bark-beetle-1-cropped.png": 27387,
	"./markdown/stora_enso_bark_beetle/sv/stora-enso-bark-beetle-2-cropped.png": 4016,
	"./markdown/wildfires_and_prescribed_fire/en/DJI_20250520210131_0006_V.jpg": 37951,
	"./markdown/wildfires_and_prescribed_fire/en/DJI_20250520215418_0015_T.jpg": 10733,
	"./markdown/wildfires_and_prescribed_fire/en/DJI_20250520215442_0016_V.jpg": 48988,
	"./markdown/wildfires_and_prescribed_fire/en/IMG_1684.png": 80599,
	"./markdown/wildfires_and_prescribed_fire/en/IMG_1686.png": 73030,
	"./markdown/wildfires_and_prescribed_fire/sv/DJI_20250520210131_0006_V.jpg": 17074,
	"./markdown/wildfires_and_prescribed_fire/sv/DJI_20250520215418_0015_T.jpg": 8684,
	"./markdown/wildfires_and_prescribed_fire/sv/DJI_20250520215442_0016_V.jpg": 27654,
	"./markdown/wildfires_and_prescribed_fire/sv/IMG_1684.png": 56581,
	"./markdown/wildfires_and_prescribed_fire/sv/IMG_1686.png": 588,
	"./markdown/wildlife/en/wildlife-boars-cropped.png": 54936,
	"./markdown/wildlife/en/wildlife-ir-zoomed-out-cropped.png": 57473,
	"./markdown/wildlife/en/wildlife-moose-cropped.png": 82245,
	"./markdown/wildlife/en/wildlife-rgb-zoomed-in-cropped.png": 93614,
	"./markdown/wildlife/sv/wildlife-boars-cropped.png": 28421,
	"./markdown/wildlife/sv/wildlife-ir-zoomed-out-cropped.png": 29556,
	"./markdown/wildlife/sv/wildlife-moose-cropped.png": 52449,
	"./markdown/wildlife/sv/wildlife-rgb-zoomed-in-cropped.png": 25624,
	"./markdown/windthrow/en/IMG_1673.png": 28533,
	"./markdown/windthrow/en/IMG_1674.png": 49449,
	"./markdown/windthrow/en/norra-observations-cropped.png": 55854,
	"./markdown/windthrow/en/norra-pre-observations-cropped.png": 40612,
	"./markdown/windthrow/en/windthrow-area.png": 80048,
	"./markdown/windthrow/en/windthrow-details-cropped.png": 85269,
	"./markdown/windthrow/en/windthrow-timber.png": 99725,
	"./markdown/windthrow/sv/IMG_1673.png": 57113,
	"./markdown/windthrow/sv/IMG_1674.png": 59680,
	"./markdown/windthrow/sv/norra-observations-cropped.png": 66526,
	"./markdown/windthrow/sv/norra-pre-observations-cropped.png": 56917,
	"./markdown/windthrow/sv/windthrow-area.png": 22015,
	"./markdown/windthrow/sv/windthrow-details-cropped.png": 28627,
	"./markdown/windthrow/sv/windthrow-timber.png": 88410,
	"./quotes/elin.png": 87131,
	"./quotes/mats.png": 97871,
	"./quotes/peter.png": 19590,
	"./quotes/sara.png": 13289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5608;